var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "-5 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ui-gambling-website-lined-icnos-casinoshunter",
    transform: "translate(-614.000000, -159.000000)",
    fill: "#252528",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square-filled",
    transform: "translate(50.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M565.76062,39.2902857 L576.638635,49.7417043 L576.699713,49.7959169 C576.885605,49.9745543 576.985701,50.2044182 577,50.4382227 L577,50.5617773 C576.985701,50.7955818 576.885605,51.0254457 576.699713,51.2040831 L576.646163,51.2479803 L565.76062,61.7097143 C565.357854,62.0967619 564.704841,62.0967619 564.302075,61.7097143 C563.899308,61.3226668 563.899308,60.6951387 564.302075,60.3080911 L574.451352,50.5617773 L564.302075,40.6919089 C563.899308,40.3048613 563.899308,39.6773332 564.302075,39.2902857 C564.704841,38.9032381 565.357854,38.9032381 565.76062,39.2902857 Z",
    id: "left",
    transform: "translate(570.500000, 50.500000) scale(-1, 1) translate(-570.500000, -50.500000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.a2bb327693f46eff45a18673911904e3.svg";
export { ForwardRef as ReactComponent };